const state = {
  themeCls: '',
  viewHeight: 1080,
  viewWidth: 1920,
  viewBackgroundColor:'',
  viewBackgroundImage:'',
  viewZoom:1,
  parts:[],
}

export default state

/* part state
{
  id:'',
  type:'',
  selected:false,
  top:0,
  left:0,
  width:0,
  height:0,
}
 */



// WEBPACK FOOTER //
// ./src/store/state.js